import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import Seo from '../components/common/Seo';

function Privacy() {
    return (
        <>
            <Seo
                title="プライバシーポリシー"
                description="Room Share Matchingのプライバシーポリシーについて。当サービスでのお客様の個人情報の取り扱いやプライバシー保護の方針を詳しく説明しています。"
                path="/privacy"
                keywords="プライバシーポリシー,個人情報保護,セキュリティ,Room Share Matching"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: 4, mt: 4, mb: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        プライバシーポリシー
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ROOMSHAREは、ユーザーの個人情報保護を最重要課題として認識し、以下のプライバシーポリシーに基づいて個人情報の収集・利用・管理を行います。
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        1. 収集する情報
                    </Typography>
                    <Typography variant="body1" paragraph>
                        当サービスでは、以下の情報を収集する場合があります：
                        • アカウント作成時の基本情報（氏名、メールアドレス等）
                        • プロフィール情報
                        • 利用履歴
                        • デバイス情報
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        2. 情報の利用目的
                    </Typography>
                    <Typography variant="body1" paragraph>
                        収集した情報は、以下の目的で利用されます：
                        • サービスの提供および改善
                        • ユーザーサポートの提供
                        • 新機能やサービスに関する情報の通知
                        • 法的義務の遵守
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        3. 情報の共有
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ROOMSHAREは、法的義務を遵守するため、またはサービスの提供に必要な場合を除き、ユーザーの同意なく第三者と個人情報を共有することはありません。
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        4. クッキーおよび追跡技術
                    </Typography>
                    <Typography variant="body1" paragraph>
                        当サービスでは、ユーザーエクスペリエンスの向上のため、クッキーやその他の追跡技術を使用しています。これらの技術は、ユーザーの設定や利用状況を記録する目的で利用されます。
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        5. 情報の保管期間
                    </Typography>
                    <Typography variant="body1" paragraph>
                        個人情報は、サービス提供に必要な期間に限り保持されます。アカウント削除時には、法令で定められた期間を除き、速やかに個人情報を削除いたします。
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        6. 国際データ転送
                    </Typography>
                    <Typography variant="body1" paragraph>
                        当サービスは日本国内で運営されていますが、サービス提供のため、お客様の情報が国外のサーバーに保存・処理される場合があります。その場合も、本プライバシーポリシーに基づき、適切な保護措置を講じます。
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        7. 法令遵守と開示請求
                    </Typography>
                    <Typography variant="body1" paragraph>
                        当社は、法令に基づく開示請求や裁判所からの命令がある場合、ユーザーの個人情報を開示することがあります。また、ユーザーや第三者の権利、財産、安全を保護するために必要と判断した場合も、情報を開示することがあります。
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 3 }}>
                        8. プライバシーポリシーの変更
                    </Typography>
                    <Typography variant="body1" paragraph>
                        本プライバシーポリシーは、法令の改正や当サービスの変更に応じて、事前の通知なく改定される場合があります。重要な変更がある場合は、サービス内での通知やメールにてお知らせいたします。
                    </Typography>
                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h6" sx={{ mt: 3 }}>
                            9. お問い合わせ
                        </Typography>
                        <Typography variant="body1" paragraph>
                            プライバシーポリシーに関するご質問やご意見、個人情報の取り扱いについてのお問い合わせは、以下の連絡先までご連絡ください：
                        </Typography>
                        <Typography variant="body1" paragraph>
                            会社名：ROOMSHARE運営事務局<br />
                            メールアドレス：privacy@roomshare.com<br />
                            所在地：〒XXX-XXXX 東京都XX区XX X-X-X
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ mt: 4, color: 'text.secondary' }}>
                        最終更新日：2024年3月XX日
                    </Typography>
                </Paper>
            </Container>
        </>
    );
}

export default Privacy; 